<template>
    <section>
        <div>
            <p>{{ title }}</p>
        </div>

        <div>
            <span v-html="description"></span>
        </div>
        <div class="movie-wrap">
            <iframe id="test" title="vimeo-player" :src="'/live/get/url?live_id='+this.live_id" frameborder="0" allowfullscreen></iframe>
        </div>
        <div>
            <span v-html="chat"></span>
        </div>
        <br/>
    </section>
</template>

<script>
    export default {
        name: "live",
        props: ['live_id'],
        data: function () {
            return {
                title: '',
                description: '',
                chat: '',
            }
        },
        mounted() {
            axios.default
                .get('/live/get/description?live_id='+this.live_id)
                .then(response => {
                    let res = response.data;
                    this.title = res.title;
                    this.description = res.description;
                    this.chat = res.chat;
                });
        },
    }
</script>

<style scoped>
.movie-wrap {
     position: relative;
     padding-bottom: 56.25%; /*アスペクト比 16:9の場合の縦幅*/
     height: 0;
     overflow: hidden;
     /* width: 80vw; */
     margin: 5vw;
}

.movie-wrap iframe {
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
}
</style>
